<template>
	<section>
		<div class="f-14"><strong>Detail Pengiriman</strong>
            <button @click="print()" class="btn btn-custom-prim float-right hide-on-mobile">Print Barcode</button>
            <button class="btn btn-custom-sec float-right hide-on-mobile" href="#modalCancel" data-toggle="modal">Batalkan</button> 
            
            <div class="barbarbar col hide-on-web">
                <div class="row">
                    <button class="col btn btn-custom-sec pd-5 mr-2" href="#modalCancel" data-toggle="modal">Batalkan</button>
                    <button @click="print()" class="col btn btn-custom-prim pd-5">Print Barcode</button>            
                </div>        
            </div>
        </div>
        <hr class="mt-4">
        <div class="row">
            <div class="col-2 margin-0 w-m-full no-flex pd-m-0 pd-0">
                <p class="f-14 f-m-12"><strong>Status Pengiriman</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-2 w-m-1-2">
                        <button class="info mb-2" :class="data.status == 1 ? 'warning': data.status == 2 ? 'wait' : data.status == 3 ? 'pickup' : data.status == 4 ? 'infoo' : data.status == 5 ? 'success' : 'warning'">{{data.col_status}}</button>
                        <p>{{data.updated_at  | moment("DD-MM-yy")}} {{data.updated_at | moment("HH:mm")}} WIB</p>
                    </div>
                    <div class="col">
                        <button data-toggle="modal" data-target="#modalDetailPengiriman" class="btn btn-custom-prim float-left ml-5">Lihat Detail</button>                
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Nomor Resi</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{data.no_resi}}</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Nomor Faktur</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{data.no_faktur}}</b>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Rute Pengiriman</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{data_rute_origin.kabupaten}}-{{data_rute_destination.kabupaten}}</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Jenis Pengiriman</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{data.type == 1 ? 'Kg' : 'Box'}}</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Sub Total</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{sub_total | currency}}</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Potongan</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{data.potongan}} %</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Total Harga</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <b>{{data.harga | currency}}</b>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2 pd-0">
                <p class="f-14 f-m-12"><strong>Keterangan Tambahan</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <button class="info warning mb-2">{{data.keterangan == null ? "Tidak ada" : data.keterangan}}</button>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-full pd-0">
                <p class="f-14 f-m-12"><strong>Data Penerima</strong></p>
            </div>
            <div class="col f-12">
                <div class="title-colee">Nama penerima / Perusahaan penerima</div>
                <p><strong>{{data_penerima.name}}</strong></p>

                <div class="title-colee">Nomor telepon</div>
                <p>{{data_penerima.phone_number}}</p>

                <div class="title-colee">Alamat</div>
                <p>
                    {{data_penerima.address}}
                </p>
                <p>Kordinat Lokasi (optional)</p>
                <GmapMap
                        class		= "maps mb-2"
                        style		= "height: 150px"
                        :center		= map.center_receive
                        :options	= mapOptions 
                        :zoom		= map.zoom_receive
                >
                    <gmap-marker
                            v-for="(item, index) in markers_receive"
                            :key="index"
                            :position="item"
                    />
                </GmapMap>
                <p class="f-14"><b>{{ map.address_receive }} </b></p>
            </div>
        </div>

        <hr>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-full pd-0">
                <p class="f-14 f-m-12"><strong>Data Pengirim</strong></p>
            </div>
            <div class="col f-12">
                <div class="title-colee">Nama penerima / Perusahaan penerima</div>
                <p><strong>{{data_pengirim.name}}</strong></p>

                <div class="title-colee">Nomor telepon</div>
                <p>{{data_pengirim.phone_number}}</p>

                <div class="title-colee">Alamat</div>
                <p>
                    {{data_pengirim.address}}
                </p>
                <p>Kordinat Lokasi (optional)</p>
                <GmapMap
                        class		= "maps mb-2"
                        style		= "height: 150px"
                        :center		= map.center_shipper
                        :options	= mapOptions 
                        :zoom		= map.zoom_shipper	
                >
                    <gmap-marker
                            v-for="(item, index) in markers_shipper"
                            :key="index"
                            :position="item"
                    />
                </GmapMap>
                <p class="f-14"><b>{{ map.address_shipper }} </b></p>
            </div>
        </div>

        <hr>
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-full pd-0">
                <p class="f-14 f-m-12"><strong>Info Barang</strong></p>
            </div>
            <div class="col f-12">
                <div class="row">
                    <div class="heuheuheuheu" v-for="(row, index) in data_barang" :key="index">
                        <div class="title-colee">Nama Barang</div>
                        <p>{{row.name}}</p>
                        <div class="title-colee">Berat</div>
                        <p>{{row.weight}} kg</p>
                        <div class="title-colee">Panjang x Lebar x Tinggi</div>
                        <p class="mb-0">{{row.length}} cm x {{row.width}} cm x {{row.tall}} cm</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-4 mb-4"></div>

        <div class="modal fade" id="modalDetailPengiriman" tabindex="-1" role="dialog" aria-labelledby="modalDetailPengirimanTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content mx-auto">                           
                    <div class="modal-body">
                        <div class="row">
                            <div class="col no-flex">
                                <p class="f-14 f-m-12 hide-on-web"><b>Status Pengiriman</b>
                                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                </button>
                                </p>
                                <GmapMap
                                        class		= "maps mb-4"
                                        style		= "height: 300px"
                                        :center		= map.center_shipment
                                        :options	= mapOptions 
                                        :zoom		= map.zoom_shipment	
                                >
                                    <gmap-marker
                                            v-for="(item, index) in markers_shipment"
                                            :key="index"
                                            :position="item" 
                                            :icon="{ url: require('../../../public/img/marker.png')}"                                           
                                    />
                                </GmapMap>
                                <p class="f-14 f-m-12"><b>Info Driver</b></p>
                                <div class="row f-12 mt-4" v-if="data_perjalanan != null">
                                    <div class="col">
                                        <div class="title-colee">Tanggal perjalanan</div>
                                        <p>{{ data_perjalanan.created_at | moment('DD-MM-yyyy')}} {{ data_perjalanan.created_at | moment('HH:mm')}} WIB</p>
                                        <div class="title-colee">Driver</div>
                                        <p>{{ data_perjalanan.driver_main.name }}</p>
                                        <div class="title-colee">Asisten</div>
                                        <p><span v-if="data_perjalanan.driver_asistant">{{ data_perjalanan.driver_asistant.name }}</span></p>
                                    </div>
                                    <div class="col">
                                        <div class="title-colee">Device</div>
                                        <p>{{ data_perjalanan.device.merk }}</p>
                                        <div class="title-colee">Nomor telepon</div>
                                        <p>{{ data_perjalanan.device.phone_number }}</p>
                                    </div>
                                    <div class="col">
                                        <div class="title-colee">Kendaraan</div>
                                        <p>{{ data_perjalanan.vehicle.merk }}</p>
                                        <div class="title-colee">Nomor polisi</div>
                                        <p>{{ data_perjalanan.vehicle.nopol }}</p>
                                    </div>
                                </div>
                                <div class="row f-12 mt-4" v-else>
                                    <div class="col">
                                        <div class="title-colee">Tanggal perjalanan</div>
                                        <p>-</p>
                                        <div class="title-colee">Driver</div>
                                        <p>-</p>
                                        <div class="title-colee">Asisten</div>
                                        <p>-</p>
                                    </div>
                                    <div class="col">
                                        <div class="title-colee">Device</div>
                                        <p>-</p>
                                        <div class="title-colee">Nomor telepon</div>
                                        <p>-</p>
                                    </div>
                                    <div class="col">
                                        <div class="title-colee">Kendaraan</div>
                                        <p>-</p>
                                        <div class="title-colee">Nomor polisi</div>
                                        <p>-</p>
                                    </div>
                                </div>
                                <p class="f-12"><i>Last update: {{data.updated_at | moment('DD-MM-yyyy')}} {{data.updated_at | moment('HH:mm')}} WIB</i></p>
                            </div>
                            <div class="col">
                                <p class="f-14 f-m-12 mb-4"><b>Status Pengiriman</b>
                                    <button type="button" class="close float-right hide-on-mobile" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                    </button> 
                                </p>
                                <div class="row" v-for="(data,index) in data_tracking" :key="index">
                                    <section class="w-full" v-if="data.status == 1">
                                        <div class="row">
                                            <div class="col f-12 w-m-1-2 pd-m-0 mr-3">
                                                <button class="info warning mb-2">Dalam Proses</button>
                                                <p class="mb-0">{{data.created_at | moment('DD-MM-yyyy')}} {{data.created_at | moment('HH:mm')}} WIB</p>
                                            </div>
                                            <div class="col">
                                                <p class="f-14 f-m-12 mb-0">Pengiriman dalam proses</p>
                                            </div>
                                        </div>
                                        <hr>
                                    </section>
                                    <section class="w-full" v-if="data.status == 2">
                                        <div class="row">
                                            <div class="col f-12 w-m-1-2 pd-m-0 mr-3">
                                                <button class="info wait mb-2">Menunggu Pickup</button>
                                                <p class="mb-0">{{data.created_at | moment('DD-MM-yyyy')}} {{data.created_at | moment('HH:mm')}} WIB</p>
                                            </div>
                                            <div class="col">
                                                <p class="f-14 f-m-12 mb-0">Pengiriman sedang menunggu pickup</p>
                                            </div>
                                        </div>
                                        <hr>
                                    </section>
                                    <section class="w-full" v-if="data.status == 3">
                                        <div class="row">
                                            <div class="col f-12 w-m-1-2 pd-m-0 mr-3">
                                                <button class="info pickup mb-2">Pickup Driver</button>
                                                <p class="mb-0">{{data.created_at | moment('DD-MM-yyyy')}} {{data.created_at | moment('HH:mm')}} WIB</p>
                                            </div>
                                            <div class="col">
                                                <p class="f-14 f-m-12 mb-0">Pengiriman sedang diambil driver</p>
                                                <div class="row">
                                                    <div class="tracking" v-for="(image,index) in data.image" :key="index">                                                
                                                        <img v-if="image.foto_atas != null" :src="image.img_url + image.foto_atas" alt="">
                                                        <img v-if="image.foto_samping != null" :src="image.img_url + image.foto_samping" alt="">
                                                    </div>
                                                </div>
                                            </div>                                            
                                        </div>                                        
                                        <hr>
                                    </section>
                                    <section class="w-full" v-if="data.status == 4">
                                        <div class="row">
                                            <div class="col f-12 w-m-1-2 pd-m-0 mr-3">
                                                <button class="info infoo mb-2">Dalam Perjalanan</button>
                                                <p class="mb-0">{{data.created_at | moment('DD-MM-yyyy')}} {{data.created_at | moment('HH:mm')}} WIB</p>
                                            </div>
                                            <div class="col">
                                                <p class="f-14 f-m-12 mb-0">Pengiriman sedang dalam perjalanan</p>
                                            </div>
                                        </div>
                                        <hr>
                                    </section>
                                    <section class="w-full" v-if="data.status == 5">
                                        <div class="row">
                                            <div class="col f-12 w-m-1-2 pd-m-0 mr-3">
                                                <button class="info success mb-2">Selesai Diterima</button>
                                                <p class="mb-0">{{data.created_at | moment('DD-MM-yyyy')}} {{data.created_at | moment('HH:mm')}} WIB</p>
                                            </div>
                                            <div class="col">
                                                <p class="f-14 f-m-12 mb-0">Pengiriman selesai diterima</p>
                                                <div class="row">
                                                    <div class="tracking" v-for="(image,index) in data.image" :key="index">                                                
                                                        <img v-if="image.foto_bukti != null" :src="image.img_url + image.foto_bukti" alt="">
                                                        <img v-if="image.signature != null" :src="image.img_url + image.signature" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <hr>
                                    </section>
                                </div>                                                                
                            </div>
                        </div>      
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalCancel" tabindex="-1" role="dialog" aria-labelledby="modalConfirmPreviewTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content mx-auto">                           
                    <div class="modal-body text-center">
                        <p>Apa anda yakin membatalkan pengiriman ini?</p>
                        <div class="row justify-content-center">
                            <button class="btn btn-secondary margin-5 pd-10-20" data-dismiss="modal">Tidak</button>
                            <button @click="deleteData" class="btn btn-primary margin-5 pd-10-20" data-dismiss="modal">Ya</button>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import Vue from "vue"
export default {
    name: 'DeliveryDetail',
    data() {
        return {
            data: [],
            data_pengirim: [],
            data_penerima: [],
            data_rute: [],
            data_rute_origin: [],
            data_rute_destination: [],
            data_barang: [],
            data_perjalanan: {
                driver_main: {},
                driver_asistant: {},
                device: {},
                vehicle: {}
            },
            data_tracking: [],
			mapOptions	: {
				streetViewControl	: false,
				fullscreenControl	: false,
				mapTypeControl		: false,
			},
            markers_receive		: [],
            markers_shipper		: [],
            markers_shipment    : [],
			map			: {
			    address_receive	: '',
			    place_receive	: '',
                center_receive	: { 
					lat	: -2.2145852388265177, 
					lng	: 117.104081069627 
                },
                address_shipper	: '',
			    place_shipper	: '',
                center_shipper	: { 
					lat	: -2.2145852388265177, 
					lng	: 117.104081069627 
                },
                center_shipment	: { 
					lat	: -2.2145852388265177, 
					lng	: 117.104081069627 
				},
                zoom_receive	: 4,
                zoom_shipper	: 4,
                zoom_shipment	: 4
            },
            sub_total: 0
        }
    },
    beforeMount() {
		let _ = this

		if ( _.$route.params.id ) {
			_.getData()
        }
    },
    methods: {
		getData() {
			let _ = this
			_.axios.get('/shipment?id=' + _.$route.params.id)
            .then(resp => {
                _.data = resp.data.data.rows
                _.data_pengirim = resp.data.data.rows.pengirim
                _.data_penerima = resp.data.data.rows.penerima
                _.data_rute = resp.data.data.rows.rute
                _.data_rute_origin = resp.data.data.rows.rute.origin
                _.data_rute_destination = resp.data.data.rows.rute.destination
                _.data_barang = resp.data.data.rows.barang

                if (resp.data.data.rows.perjalanan != null){
                    _.data_perjalanan = resp.data.data.rows.perjalanan.perjalanan
                }else{
                    _.data_perjalanan = null
                }               
                _.data_tracking = resp.data.data.rows.tracking

                if (_.data.type == 1){                                    
                    if (Math.ceil((_.data.total_volume*1000000) / 6000) > _.data.total_berat){
                        _.sub_total = Math.ceil((_.data.total_volume*1000000) / 6000) * _.data.rute.price                    
                    }else{
                        _.sub_total = _.data.total_berat * _.data.rute.price 
                    }
                } else {
                    _.sub_total = _.data.total_barang * _.data.rute.price_box
                }

                _.addMarkerReceive(_.data_penerima)
                _.addMarkerShipper(_.data_pengirim)
                _.addMarkerShipment(_.data)
            })
            .catch(err => {
                console.log(err.response)
            })
        },
        print() {
			let _ = this

            if(localStorage.getItem('bluetooth_print') == 'true') {
                _.axios.get('/shipment/print?format=png&no_resi=' + _.data.no_resi, {responseType: 'arraybuffer'})
                    .then(resp => {
                        let blob    = new Blob([resp.data], { type: 'image/png' })
                        
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);

                        reader.onloadend = function(e) {
                            var imageBase64 = e.target.result.split(',')[1];
                            var intentUrl = "intent://print?package=com.app.bisacekprint&image=" + encodeURIComponent(imageBase64) + "#Intent;scheme=bisacekprint;end";
                            window.location.href = intentUrl;
                        };
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
            else {
                _.axios.get('/shipment/print?no_resi=' + _.data.no_resi, {responseType: 'arraybuffer'})
                    .then(resp => {
                        let blob    = new Blob([resp.data], { type: 'application/pdf' })
                        let link    = document.createElement('a')
                        link.href   = window.URL.createObjectURL(blob)
                        link.target = "_blank"
                        // link.download = 'QRCODE_' + _.data.no_resi
                        link.click()
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
        },
        addMarkerReceive(data) {
		    let _ = this
			if(data.lat != null && data.lng != null){
				var latLng = {
					lat: parseFloat(data.lat),
					lng: parseFloat(data.lng)
				}

				_.markers_receive 		= [latLng]
				_.map.center_receive 	= latLng
				_.map.zoom_receive 		= 18

				Vue.$geocoder.send(latLng, response => {
					_.map.address_receive = response.results[0].formatted_address
				})
			}	
		},
        addMarkerShipper(data) {
		    let _ = this
			if(data.lat != null && data.lng != null){
				var latLng = {
					lat: parseFloat(data.lat),
					lng: parseFloat(data.lng)
				}

				_.markers_shipper 		= [latLng]
				_.map.center_shipper 	= latLng
				_.map.zoom_shipper 		= 18

				Vue.$geocoder.send(latLng, response => {
					_.map.address_shipper = response.results[0].formatted_address
				})
			}	
        },
        addMarkerShipment(data) {
            let _ = this
            var latLng = ''
			if(data.lat != null && data.lng != null){
				latLng = {
					lat: parseFloat(data.lat),
					lng: parseFloat(data.lng)
				}

				_.markers_shipment 		= [latLng]
				_.map.center_shipment 	= latLng
				_.map.zoom_shipment     = 18

				Vue.$geocoder.send(latLng, response => {
					_.map.address_shipment = response.results[0].formatted_address
				})
            } else {
                latLng = {
					lat: parseFloat(_.map.center_shipment.lat),
					lng: parseFloat(_.map.center_shipment.lng)
				}

				_.markers_shipment 		= [latLng]
				_.map.center_shipment 	= latLng
				_.map.zoom_shipment     = 4

				Vue.$geocoder.send(latLng, response => {
					_.map.address_shipment = response.results[0].formatted_address
				})
            }
		},
        deleteData() {
			let _ = this
			_.axios.delete('/shipment', { data: { id: _.$route.params.id } })
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
                            name: 'DeliveryIndex',
                            params: {
                                status: 'delete'
                            }
                        })	
					}
				})
				.catch(err => {
					console.log(err)
					console.log(err.response)
				})
		}
    },
     created(){
        this.getData()
    },
    computed: {
        authHeaders () {
            return {
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        },
    },
}
</script>